/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Lms.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddIltResourceFileRequest,
  AddIltResourceLinkRequest,
  AttendanceRefusalDto,
  BookIltSessionRequest,
  CheckoutSessionResponse,
  DiscountCodeRequest,
  DiscountCodeValidationResponse,
  DiscountSeatOrderResponse,
  HttpValidationProblemDetails,
  IltBookingCancelledDto,
  IltBookingDto,
  IltBookingRefusalDto,
  IltCourseDto,
  IltFeedbackFormDto,
  IltFeedbackRefusalDto,
  IltResourceDto,
  InstructorLedUnsubscribeFromRemindersParams,
  InvoiceSeatOrderResponse,
  MarkAttendanceRequest,
  ProblemDetails,
  SessionDiscountSeatOrderRequest,
  SessionInvoiceSeatOrderRequest,
  SessionResourcesDto,
  SessionRosterDto,
  SessionSeatOrderCheckoutRequest,
  SubmitIltFeedbackRequest,
  UpcomingIltCourseDto
} from '../../../types/api';

import { apiClient } from '../../client/api-client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Turns off the session reminder emails of the learner the signed token was issued to, as the unsubscribe link in a session reminder and its one-click List-Unsubscribe header do. No sign-in is needed: the token, from the reminder's link, decides which learner, and only their reminder setting changes. Their reminders already scheduled are cancelled. Emails about their bookings (confirmation, session changed or cancelled) still go out. Answers 204 when reminders are off (also when they already were, or the account no longer exists), and 400 for a token that is missing, changed or wasn't issued here. Open to everyone. Verified unsubscribe links are limited to 10 requests per minute per link, independently of the sender's IP traffic. Missing and invalid tokens share a single 10-request-per-minute limit and remain subject to the global limit of 100 unauthenticated requests per minute per IP.
 * @summary Turn off a learner's face-to-face session reminders from an unsubscribe link
 */
export const instructorLedUnsubscribeFromReminders = (
    params?: InstructorLedUnsubscribeFromRemindersParams,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/instructor-led/reminders/unsubscribe`, method: 'POST',
        params, signal
    },
      );
    }




export const getInstructorLedUnsubscribeFromRemindersMutationKey = () => ['instructorLedUnsubscribeFromReminders'] as const;

export const getInstructorLedUnsubscribeFromRemindersMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedUnsubscribeFromReminders>>, TError,InstructorLedUnsubscribeFromRemindersMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof instructorLedUnsubscribeFromReminders>>, TError,InstructorLedUnsubscribeFromRemindersMutationVariables, TContext> => {

const mutationKey = getInstructorLedUnsubscribeFromRemindersMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof instructorLedUnsubscribeFromReminders>>, InstructorLedUnsubscribeFromRemindersMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  instructorLedUnsubscribeFromReminders(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstructorLedUnsubscribeFromRemindersMutationResult = NonNullable<Awaited<ReturnType<typeof instructorLedUnsubscribeFromReminders>>>

    export type InstructorLedUnsubscribeFromRemindersMutationError = ProblemDetails
    export type InstructorLedUnsubscribeFromRemindersMutationVariables = {params?: InstructorLedUnsubscribeFromRemindersParams}

    /**
 * @summary Turn off a learner's face-to-face session reminders from an unsubscribe link
 */
export const useInstructorLedUnsubscribeFromReminders = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedUnsubscribeFromReminders>>, TError,InstructorLedUnsubscribeFromRemindersMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof instructorLedUnsubscribeFromReminders>>,
        TError,
        InstructorLedUnsubscribeFromRemindersMutationVariables,
        TContext
      > => {
      return useMutation(getInstructorLedUnsubscribeFromRemindersMutationOptions(options), queryClient);
    }
    /**
 * Returns the published instructor-led courses that have an upcoming session, ordered by their next session's start (soonest first), each with that session's date, time and venue and the course's price (GBP pence, null when free). A session is upcoming until it starts; cancelled sessions don't count, so a course whose sessions are all past or cancelled, or that has none, is left out. While the payments flag is off, paid courses are left out. Open to everyone. Returns 404 while the ilt feature flag is off
 * @summary List upcoming face-to-face training
 */
export const instructorLedListUpcomingCourses = (

 signal?: AbortSignal
) => {


      return apiClient<UpcomingIltCourseDto[]>(
      {url: `/api/instructor-led/courses`, method: 'GET', signal
    },
      );
    }




export const getInstructorLedListUpcomingCoursesQueryKey = () => {
    return [
    `/api/instructor-led/courses`
    ] as const;
    }


export const getInstructorLedListUpcomingCoursesQueryOptions = <TData = Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInstructorLedListUpcomingCoursesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>> = ({ signal }) => instructorLedListUpcomingCourses(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InstructorLedListUpcomingCoursesQueryResult = NonNullable<Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>>
export type InstructorLedListUpcomingCoursesQueryError = void


export function useInstructorLedListUpcomingCourses<TData = Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>,
          TError,
          Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInstructorLedListUpcomingCourses<TData = Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>,
          TError,
          Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInstructorLedListUpcomingCourses<TData = Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List upcoming face-to-face training
 */

export function useInstructorLedListUpcomingCourses<TData = Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedListUpcomingCourses>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInstructorLedListUpcomingCoursesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns a published instructor-led course's title, short description, learning outcomes, picture, length (in minutes, shown in its hours or days unit), audience, level and price (GBP pence, null when free), and its upcoming sessions (not cancelled and not started), soonest first, each with its UK and UTC times, venue, capacity, spaces left (capacity minus confirmed bookings; 0 when fully booked) and whether the signed-in learner has booked it (always false for visitors) and, if so, whether they can cancel it online (canCancel, until cancellableUntil) or the cancellation cut-off has passed (isTooLateToCancel). The list may be empty. includedInPathTitle names the paid learning path the signed-in learner has access to whose price includes a place on this paid course, so its sessions are booked without checkout (LMS-201); null otherwise, and once a session they kept a booking on has used the place. startedBookedSessions lists the sessions of the course the signed-in learner holds a booking on (not cancelled) that have started, most recent first, so the page still shows their session and its shared files and links during and after it (LMS-143); empty for visitors. Open to everyone. Returns 404 for an online course, a course that isn't published or is archived, a paid course while the payments flag is off, a Restricted course the caller has no access to (admins with Courses.Read see it), and every course while the ilt feature flag is off
 * @summary Get a face-to-face training course
 */
export const instructorLedGetCourse = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<IltCourseDto>(
      {url: `/api/instructor-led/courses/${id}`, method: 'GET', signal
    },
      );
    }




export const getInstructorLedGetCourseQueryKey = (id: string,) => {
    return [
    `/api/instructor-led/courses/${id}`
    ] as const;
    }


export const getInstructorLedGetCourseQueryOptions = <TData = Awaited<ReturnType<typeof instructorLedGetCourse>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetCourse>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInstructorLedGetCourseQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof instructorLedGetCourse>>> = ({ signal }) => instructorLedGetCourse(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetCourse>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InstructorLedGetCourseQueryResult = NonNullable<Awaited<ReturnType<typeof instructorLedGetCourse>>>
export type InstructorLedGetCourseQueryError = void


export function useInstructorLedGetCourse<TData = Awaited<ReturnType<typeof instructorLedGetCourse>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetCourse>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof instructorLedGetCourse>>,
          TError,
          Awaited<ReturnType<typeof instructorLedGetCourse>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInstructorLedGetCourse<TData = Awaited<ReturnType<typeof instructorLedGetCourse>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetCourse>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof instructorLedGetCourse>>,
          TError,
          Awaited<ReturnType<typeof instructorLedGetCourse>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInstructorLedGetCourse<TData = Awaited<ReturnType<typeof instructorLedGetCourse>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetCourse>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a face-to-face training course
 */

export function useInstructorLedGetCourse<TData = Awaited<ReturnType<typeof instructorLedGetCourse>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetCourse>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInstructorLedGetCourseQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Books a seat on an upcoming session of a free instructor-led course for the signed-in learner and returns the booking with its course and session. A paid course is booked here too, without checkout, when it is in a paid learning path the learner bought or was given access to: the path's price includes one place on each of its face-to-face courses, one booking on the course at a time (LMS-201). The body carries the session's UK start and end and venue as the learner confirmed them (as the course page sent them); the seat is only booked while the session still has them. The learner is emailed a confirmation. When two learners take the last seat at the same moment only one gets it. Returns 409 with a reason and a message when the session is fully booked (fully-booked), the learner has already booked it (already-booked), it has been cancelled or has started (unavailable), the course is paid and no learning path of the learner's includes a place on it, or the place their path includes was used by a session they kept a booking on (payment-required), their learning path's place on the course is held by their booking on another of its sessions (course-already-booked), their own checkout for the session has been paid and is being confirmed (checkout-in-progress; an unpaid one is expired first, freeing its seat), or the session's date, time or venue has changed since the learner confirmed it (details-changed). Returns 404 for a session of a course learners can't see, and while the ilt feature flag is off
 * @summary Book a seat on a face-to-face training session
 */
export const instructorLedBookSession = (
    sessionId: string,
    bookIltSessionRequest: BookIltSessionRequest,
 signal?: AbortSignal
) => {


      return apiClient<IltBookingDto>(
      {url: `/api/instructor-led/sessions/${sessionId}/booking`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bookIltSessionRequest, signal
    },
      );
    }




export const getInstructorLedBookSessionMutationKey = () => ['instructorLedBookSession'] as const;

export const getInstructorLedBookSessionMutationOptions = <TError = void | IltBookingRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedBookSession>>, TError,InstructorLedBookSessionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof instructorLedBookSession>>, TError,InstructorLedBookSessionMutationVariables, TContext> => {

const mutationKey = getInstructorLedBookSessionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof instructorLedBookSession>>, InstructorLedBookSessionMutationVariables> = (props) => {
          const {sessionId,data} = props ?? {};

          return  instructorLedBookSession(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstructorLedBookSessionMutationResult = NonNullable<Awaited<ReturnType<typeof instructorLedBookSession>>>
    export type InstructorLedBookSessionMutationBody = BookIltSessionRequest
    export type InstructorLedBookSessionMutationError = void | IltBookingRefusalDto
    export type InstructorLedBookSessionMutationVariables = {sessionId: string;data: BookIltSessionRequest}

    /**
 * @summary Book a seat on a face-to-face training session
 */
export const useInstructorLedBookSession = <TError = void | IltBookingRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedBookSession>>, TError,InstructorLedBookSessionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof instructorLedBookSession>>,
        TError,
        InstructorLedBookSessionMutationVariables,
        TContext
      > => {
      return useMutation(getInstructorLedBookSessionMutationOptions(options), queryClient);
    }
    /**
 * Cancels the signed-in learner's booking on the session, so its seat goes back to the session for someone else (spaces left goes up by one) and the learner can book it again while spaces are left. A booking can be cancelled until the cancellation cut-off (InstructorLed:CancellationCutOffHours, hours before the session starts). Returns 204 once a booking the learner didn't pay for is cancelled. A booking paid for through Stripe is cancelled the same way and, when InstructorLed:RefundLearnerCancellations is on, its payment refunded through Stripe (LMS-186): it returns 200 with what happened to the payment (refunded, not-refunded, or refund-failed, when the booking is cancelled but the refund didn't go through) and a message for the learner. Returns 409 with a reason and a message when the cut-off has passed (too-late-to-cancel) or an admin has cancelled the session (session-cancelled). Returns 404 when the learner holds no active booking on the session, and while the ilt feature flag is off
 * @summary Cancel the learner's booking on a face-to-face training session
 */
export const instructorLedCancelBooking = (
    sessionId: string,
 signal?: AbortSignal
) => {


      return apiClient<IltBookingCancelledDto | void>(
      {url: `/api/instructor-led/sessions/${sessionId}/booking`, method: 'DELETE', signal
    },
      );
    }




export const getInstructorLedCancelBookingMutationKey = () => ['instructorLedCancelBooking'] as const;

export const getInstructorLedCancelBookingMutationOptions = <TError = void | IltBookingRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedCancelBooking>>, TError,InstructorLedCancelBookingMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof instructorLedCancelBooking>>, TError,InstructorLedCancelBookingMutationVariables, TContext> => {

const mutationKey = getInstructorLedCancelBookingMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof instructorLedCancelBooking>>, InstructorLedCancelBookingMutationVariables> = (props) => {
          const {sessionId} = props ?? {};

          return  instructorLedCancelBooking(sessionId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstructorLedCancelBookingMutationResult = NonNullable<Awaited<ReturnType<typeof instructorLedCancelBooking>>>

    export type InstructorLedCancelBookingMutationError = void | IltBookingRefusalDto
    export type InstructorLedCancelBookingMutationVariables = {sessionId: string}

    /**
 * @summary Cancel the learner's booking on a face-to-face training session
 */
export const useInstructorLedCancelBooking = <TError = void | IltBookingRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedCancelBooking>>, TError,InstructorLedCancelBookingMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof instructorLedCancelBooking>>,
        TError,
        InstructorLedCancelBookingMutationVariables,
        TContext
      > => {
      return useMutation(getInstructorLedCancelBookingMutationOptions(options), queryClient);
    }
    /**
 * Holds a seat on an upcoming session of a paid instructor-led course for the signed-in learner and creates a Stripe checkout for it, priced from the course's price (the client sends no amount). The body carries the session's UK start and end and venue as the learner confirmed them; the seat is only held while the session still has them. The held seat counts as taken, so others see one space fewer, until the payment books it (through the Stripe webhook, which emails the learner a confirmation) or the checkout expires (after about 30 minutes), fails or is cancelled. Starting again expires the learner's earlier checkout for the session. Returns 409 with a reason and a message when the session is fully booked (fully-booked), the learner has already booked it (already-booked), it has been cancelled or has started (unavailable), its details have changed (details-changed), an earlier checkout for it has been paid and is being confirmed (checkout-in-progress), or a learning path the learner has access to includes a place on the course that is still free to book, so it is booked without paying (included-in-path, LMS-201). Returns 400 for a free course's session, and 404 for a session of a course learners can't see and while the ilt or payments feature flag is off
 * @summary Start paying for a seat on a face-to-face training session
 */
export const instructorLedStartSessionCheckout = (
    sessionId: string,
    bookIltSessionRequest: BookIltSessionRequest,
 signal?: AbortSignal
) => {


      return apiClient<CheckoutSessionResponse>(
      {url: `/api/instructor-led/sessions/${sessionId}/checkout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bookIltSessionRequest, signal
    },
      );
    }




export const getInstructorLedStartSessionCheckoutMutationKey = () => ['instructorLedStartSessionCheckout'] as const;

export const getInstructorLedStartSessionCheckoutMutationOptions = <TError = ProblemDetails | void | IltBookingRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedStartSessionCheckout>>, TError,InstructorLedStartSessionCheckoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof instructorLedStartSessionCheckout>>, TError,InstructorLedStartSessionCheckoutMutationVariables, TContext> => {

const mutationKey = getInstructorLedStartSessionCheckoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof instructorLedStartSessionCheckout>>, InstructorLedStartSessionCheckoutMutationVariables> = (props) => {
          const {sessionId,data} = props ?? {};

          return  instructorLedStartSessionCheckout(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstructorLedStartSessionCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof instructorLedStartSessionCheckout>>>
    export type InstructorLedStartSessionCheckoutMutationBody = BookIltSessionRequest
    export type InstructorLedStartSessionCheckoutMutationError = ProblemDetails | void | IltBookingRefusalDto
    export type InstructorLedStartSessionCheckoutMutationVariables = {sessionId: string;data: BookIltSessionRequest}

    /**
 * @summary Start paying for a seat on a face-to-face training session
 */
export const useInstructorLedStartSessionCheckout = <TError = ProblemDetails | void | IltBookingRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedStartSessionCheckout>>, TError,InstructorLedStartSessionCheckoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof instructorLedStartSessionCheckout>>,
        TError,
        InstructorLedStartSessionCheckoutMutationVariables,
        TContext
      > => {
      return useMutation(getInstructorLedStartSessionCheckoutMutationOptions(options), queryClient);
    }
    /**
 * Holds quantity seats on an upcoming session of a paid instructor-led course for the signed-in purchaser to hand out by invite, and creates a Stripe checkout for them, priced at the course's price per seat (the client sends no amount). The body carries the number of seats (1 up to the session's spaces left) and the session's UK start and end and venue as the purchaser confirmed them; the seats are only held while the session still has them. The held seats count as taken, so others see that many spaces fewer, until the payment completes (through the Stripe webhook, which creates a seat order for the session with one unredeemed seat for each place; the seats stay taken for it) or the checkout expires (after about 30 minutes), fails or is cancelled (DELETE checkout/{checkoutId}), which frees them. Seats still unredeemed when the session starts lapse, with no refund. Buying seats doesn't book the purchaser, and their own booking on the session doesn't stop them buying seats. Starting again expires the purchaser's earlier checkout for the session. Returns 409 with a reason and a message when the session is fully booked (fully-booked), has fewer spaces left than the seats asked for (not-enough-spaces), starts before the checkout could close (about 30 minutes), so the seats would lapse before they were paid for (too-soon-to-buy-seats), has been cancelled or has started (unavailable), its details have changed (details-changed), or an earlier checkout for it has been paid and is being confirmed (checkout-in-progress). Returns 400 for a free course's session and for a number of seats outside 1 to the most an order can buy, and 404 for a session of a course learners can't see and while the ilt, payments or seat-orders feature flag is off
 * @summary Start paying for several seats on a face-to-face training session
 */
export const instructorLedStartSessionSeatOrderCheckout = (
    sessionId: string,
    sessionSeatOrderCheckoutRequest: SessionSeatOrderCheckoutRequest,
 signal?: AbortSignal
) => {


      return apiClient<CheckoutSessionResponse>(
      {url: `/api/instructor-led/sessions/${sessionId}/seat-checkout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sessionSeatOrderCheckoutRequest, signal
    },
      );
    }




export const getInstructorLedStartSessionSeatOrderCheckoutMutationKey = () => ['instructorLedStartSessionSeatOrderCheckout'] as const;

export const getInstructorLedStartSessionSeatOrderCheckoutMutationOptions = <TError = ProblemDetails | void | IltBookingRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedStartSessionSeatOrderCheckout>>, TError,InstructorLedStartSessionSeatOrderCheckoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof instructorLedStartSessionSeatOrderCheckout>>, TError,InstructorLedStartSessionSeatOrderCheckoutMutationVariables, TContext> => {

const mutationKey = getInstructorLedStartSessionSeatOrderCheckoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof instructorLedStartSessionSeatOrderCheckout>>, InstructorLedStartSessionSeatOrderCheckoutMutationVariables> = (props) => {
          const {sessionId,data} = props ?? {};

          return  instructorLedStartSessionSeatOrderCheckout(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstructorLedStartSessionSeatOrderCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof instructorLedStartSessionSeatOrderCheckout>>>
    export type InstructorLedStartSessionSeatOrderCheckoutMutationBody = SessionSeatOrderCheckoutRequest
    export type InstructorLedStartSessionSeatOrderCheckoutMutationError = ProblemDetails | void | IltBookingRefusalDto
    export type InstructorLedStartSessionSeatOrderCheckoutMutationVariables = {sessionId: string;data: SessionSeatOrderCheckoutRequest}

    /**
 * @summary Start paying for several seats on a face-to-face training session
 */
export const useInstructorLedStartSessionSeatOrderCheckout = <TError = ProblemDetails | void | IltBookingRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedStartSessionSeatOrderCheckout>>, TError,InstructorLedStartSessionSeatOrderCheckoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof instructorLedStartSessionSeatOrderCheckout>>,
        TError,
        InstructorLedStartSessionSeatOrderCheckoutMutationVariables,
        TContext
      > => {
      return useMutation(getInstructorLedStartSessionSeatOrderCheckoutMutationOptions(options), queryClient);
    }
    /**
 * Places an order for quantity seats on an upcoming session of a paid instructor-led course, priced at the course's price per seat, to be paid by invoice (LMS-151): there is no Stripe checkout. The body carries the number of seats (1 up to the session's spaces left), the session's UK start and end and venue as the purchaser confirmed them, and the billing name or organisation, email and address, and optionally a PO number and a VAT number. The seats are held on the session with the same conditional update as a card order, so others see that many spaces fewer while the order is open; cancelling the order gives them back. The order starts Awaiting invoice, is listed in My purchases, and the admins who manage orders are emailed. Buying seats doesn't book the purchaser. Returns 409 with a reason and a message when the session is fully booked (fully-booked), has fewer spaces left than the seats asked for (not-enough-spaces), has been cancelled or has started (unavailable), or its details have changed (details-changed). Returns 400 for missing or invalid billing details, a free course's session and a number of seats outside 1 to the most an order can buy, and 404 for a session of a course learners can't see and while the ilt, payments or seat-orders feature flag is off
 * @summary Order several seats on a face-to-face training session, paid by invoice
 */
export const instructorLedPlaceSessionInvoiceSeatOrder = (
    sessionId: string,
    sessionInvoiceSeatOrderRequest: SessionInvoiceSeatOrderRequest,
 signal?: AbortSignal
) => {


      return apiClient<InvoiceSeatOrderResponse>(
      {url: `/api/instructor-led/sessions/${sessionId}/seat-invoice-order`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sessionInvoiceSeatOrderRequest, signal
    },
      );
    }




export const getInstructorLedPlaceSessionInvoiceSeatOrderMutationKey = () => ['instructorLedPlaceSessionInvoiceSeatOrder'] as const;

export const getInstructorLedPlaceSessionInvoiceSeatOrderMutationOptions = <TError = ProblemDetails | void | IltBookingRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedPlaceSessionInvoiceSeatOrder>>, TError,InstructorLedPlaceSessionInvoiceSeatOrderMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof instructorLedPlaceSessionInvoiceSeatOrder>>, TError,InstructorLedPlaceSessionInvoiceSeatOrderMutationVariables, TContext> => {

const mutationKey = getInstructorLedPlaceSessionInvoiceSeatOrderMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof instructorLedPlaceSessionInvoiceSeatOrder>>, InstructorLedPlaceSessionInvoiceSeatOrderMutationVariables> = (props) => {
          const {sessionId,data} = props ?? {};

          return  instructorLedPlaceSessionInvoiceSeatOrder(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstructorLedPlaceSessionInvoiceSeatOrderMutationResult = NonNullable<Awaited<ReturnType<typeof instructorLedPlaceSessionInvoiceSeatOrder>>>
    export type InstructorLedPlaceSessionInvoiceSeatOrderMutationBody = SessionInvoiceSeatOrderRequest
    export type InstructorLedPlaceSessionInvoiceSeatOrderMutationError = ProblemDetails | void | IltBookingRefusalDto
    export type InstructorLedPlaceSessionInvoiceSeatOrderMutationVariables = {sessionId: string;data: SessionInvoiceSeatOrderRequest}

    /**
 * @summary Order several seats on a face-to-face training session, paid by invoice
 */
export const useInstructorLedPlaceSessionInvoiceSeatOrder = <TError = ProblemDetails | void | IltBookingRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedPlaceSessionInvoiceSeatOrder>>, TError,InstructorLedPlaceSessionInvoiceSeatOrderMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof instructorLedPlaceSessionInvoiceSeatOrder>>,
        TError,
        InstructorLedPlaceSessionInvoiceSeatOrderMutationVariables,
        TContext
      > => {
      return useMutation(getInstructorLedPlaceSessionInvoiceSeatOrderMutationOptions(options), queryClient);
    }
    /**
 * Places a £0 order for quantity seats on an upcoming session of a paid instructor-led course, paid for by a full-comp discount code for the course (LMS-187): there is no Stripe checkout. The body carries the number of seats (1 up to the session's spaces left), the session's UK start and end and venue as the purchaser confirmed them, and the code. One redemption of the code is used, and the seats are held on the session with the same conditional update as a card or invoice order, together with the order: they stay taken by it, and go back to the session if it is cancelled. The order is Completed, so its seats can be handed out by invite straight away, and is listed in My purchases. Buying seats doesn't book the purchaser. Returns 400 for an unknown, expired or used-up code or one for another course (with the same messages as redeeming a code yourself, and nothing is ordered or used), a free course's session and a number of seats outside 1 to the most an order can buy; 409 with a reason and a message when the session is fully booked (fully-booked), has fewer spaces left than the seats asked for (not-enough-spaces), has been cancelled or has started (unavailable), or its details have changed (details-changed); and 404 for a session of a course learners can't see and while the ilt, payments or seat-orders feature flag is off. A free Restricted course's seats (LMS-196) are ordered here too, at £0 with no code, for a purchaser an admin granted to buy them. On any Restricted course only such a purchaser can buy seats; anyone else gets 404
 * @summary Order several seats on a face-to-face training session with a discount code
 */
export const instructorLedPlaceSessionDiscountSeatOrder = (
    sessionId: string,
    sessionDiscountSeatOrderRequest: SessionDiscountSeatOrderRequest,
 signal?: AbortSignal
) => {


      return apiClient<DiscountSeatOrderResponse>(
      {url: `/api/instructor-led/sessions/${sessionId}/seat-discount-order`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sessionDiscountSeatOrderRequest, signal
    },
      );
    }




export const getInstructorLedPlaceSessionDiscountSeatOrderMutationKey = () => ['instructorLedPlaceSessionDiscountSeatOrder'] as const;

export const getInstructorLedPlaceSessionDiscountSeatOrderMutationOptions = <TError = ProblemDetails | void | IltBookingRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedPlaceSessionDiscountSeatOrder>>, TError,InstructorLedPlaceSessionDiscountSeatOrderMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof instructorLedPlaceSessionDiscountSeatOrder>>, TError,InstructorLedPlaceSessionDiscountSeatOrderMutationVariables, TContext> => {

const mutationKey = getInstructorLedPlaceSessionDiscountSeatOrderMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof instructorLedPlaceSessionDiscountSeatOrder>>, InstructorLedPlaceSessionDiscountSeatOrderMutationVariables> = (props) => {
          const {sessionId,data} = props ?? {};

          return  instructorLedPlaceSessionDiscountSeatOrder(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstructorLedPlaceSessionDiscountSeatOrderMutationResult = NonNullable<Awaited<ReturnType<typeof instructorLedPlaceSessionDiscountSeatOrder>>>
    export type InstructorLedPlaceSessionDiscountSeatOrderMutationBody = SessionDiscountSeatOrderRequest
    export type InstructorLedPlaceSessionDiscountSeatOrderMutationError = ProblemDetails | void | IltBookingRefusalDto
    export type InstructorLedPlaceSessionDiscountSeatOrderMutationVariables = {sessionId: string;data: SessionDiscountSeatOrderRequest}

    /**
 * @summary Order several seats on a face-to-face training session with a discount code
 */
export const useInstructorLedPlaceSessionDiscountSeatOrder = <TError = ProblemDetails | void | IltBookingRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedPlaceSessionDiscountSeatOrder>>, TError,InstructorLedPlaceSessionDiscountSeatOrderMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof instructorLedPlaceSessionDiscountSeatOrder>>,
        TError,
        InstructorLedPlaceSessionDiscountSeatOrderMutationVariables,
        TContext
      > => {
      return useMutation(getInstructorLedPlaceSessionDiscountSeatOrderMutationOptions(options), queryClient);
    }
    /**
 * Checks that a discount code pays for a seat order on a session of a paid instructor-led course (LMS-187), and returns the price per seat with and without it (£0 for a full-comp code), without using it, holding seats or ordering anything. Refused with 400 for an unknown, expired or used-up code or one for another course, with the same messages as redeeming a code yourself; 404 for a session of a course learners can't see and while the ilt, payments or seat-orders feature flag is off
 * @summary Check a discount code for a seat order on a face-to-face training session
 */
export const instructorLedValidateSessionSeatOrderDiscountCode = (
    sessionId: string,
    discountCodeRequest: DiscountCodeRequest,
 signal?: AbortSignal
) => {


      return apiClient<DiscountCodeValidationResponse>(
      {url: `/api/instructor-led/sessions/${sessionId}/seat-discount-order/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: discountCodeRequest, signal
    },
      );
    }




export const getInstructorLedValidateSessionSeatOrderDiscountCodeMutationKey = () => ['instructorLedValidateSessionSeatOrderDiscountCode'] as const;

export const getInstructorLedValidateSessionSeatOrderDiscountCodeMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedValidateSessionSeatOrderDiscountCode>>, TError,InstructorLedValidateSessionSeatOrderDiscountCodeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof instructorLedValidateSessionSeatOrderDiscountCode>>, TError,InstructorLedValidateSessionSeatOrderDiscountCodeMutationVariables, TContext> => {

const mutationKey = getInstructorLedValidateSessionSeatOrderDiscountCodeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof instructorLedValidateSessionSeatOrderDiscountCode>>, InstructorLedValidateSessionSeatOrderDiscountCodeMutationVariables> = (props) => {
          const {sessionId,data} = props ?? {};

          return  instructorLedValidateSessionSeatOrderDiscountCode(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstructorLedValidateSessionSeatOrderDiscountCodeMutationResult = NonNullable<Awaited<ReturnType<typeof instructorLedValidateSessionSeatOrderDiscountCode>>>
    export type InstructorLedValidateSessionSeatOrderDiscountCodeMutationBody = DiscountCodeRequest
    export type InstructorLedValidateSessionSeatOrderDiscountCodeMutationError = ProblemDetails | void
    export type InstructorLedValidateSessionSeatOrderDiscountCodeMutationVariables = {sessionId: string;data: DiscountCodeRequest}

    /**
 * @summary Check a discount code for a seat order on a face-to-face training session
 */
export const useInstructorLedValidateSessionSeatOrderDiscountCode = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedValidateSessionSeatOrderDiscountCode>>, TError,InstructorLedValidateSessionSeatOrderDiscountCodeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof instructorLedValidateSessionSeatOrderDiscountCode>>,
        TError,
        InstructorLedValidateSessionSeatOrderDiscountCodeMutationVariables,
        TContext
      > => {
      return useMutation(getInstructorLedValidateSessionSeatOrderDiscountCodeMutationOptions(options), queryClient);
    }
    /**
 * Expires the signed-in learner's checkout for the session (checkoutId, from the address Stripe's cancel link returns to) at Stripe and frees the seat it held straight away, as when they cancel on Stripe's page. A purchaser's checkout for several seats (LMS-190) is cancelled the same way, freeing all its seats. Only that checkout of the learner's is cancelled, so a late return from an earlier checkout can't cancel a newer one. Returns 204 once it is cancelled, and when there is nothing to cancel (it ended already, or isn't theirs). Returns 409 with reason checkout-in-progress when it has been paid, so the Stripe webhook books it; 503 when Stripe wouldn't close it (try again); and 404 while the ilt or payments feature flag is off
 * @summary Cancel paying for a seat on a face-to-face training session
 */
export const instructorLedCancelSessionCheckout = (
    sessionId: string,
    checkoutId: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/instructor-led/sessions/${sessionId}/checkout/${checkoutId}`, method: 'DELETE', signal
    },
      );
    }




export const getInstructorLedCancelSessionCheckoutMutationKey = () => ['instructorLedCancelSessionCheckout'] as const;

export const getInstructorLedCancelSessionCheckoutMutationOptions = <TError = void | IltBookingRefusalDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedCancelSessionCheckout>>, TError,InstructorLedCancelSessionCheckoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof instructorLedCancelSessionCheckout>>, TError,InstructorLedCancelSessionCheckoutMutationVariables, TContext> => {

const mutationKey = getInstructorLedCancelSessionCheckoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof instructorLedCancelSessionCheckout>>, InstructorLedCancelSessionCheckoutMutationVariables> = (props) => {
          const {sessionId,checkoutId} = props ?? {};

          return  instructorLedCancelSessionCheckout(sessionId,checkoutId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstructorLedCancelSessionCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof instructorLedCancelSessionCheckout>>>

    export type InstructorLedCancelSessionCheckoutMutationError = void | IltBookingRefusalDto | ProblemDetails
    export type InstructorLedCancelSessionCheckoutMutationVariables = {sessionId: string;checkoutId: string}

    /**
 * @summary Cancel paying for a seat on a face-to-face training session
 */
export const useInstructorLedCancelSessionCheckout = <TError = void | IltBookingRefusalDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedCancelSessionCheckout>>, TError,InstructorLedCancelSessionCheckoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof instructorLedCancelSessionCheckout>>,
        TError,
        InstructorLedCancelSessionCheckoutMutationVariables,
        TContext
      > => {
      return useMutation(getInstructorLedCancelSessionCheckoutMutationOptions(options), queryClient);
    }
    /**
 * Returns who has booked the session, read afresh each time: each learner holding a booking (cancelled bookings drop off), by name, with their email, when they booked and their attendance (NotMarked until marked, then Attended or NotAttended, with who marked it and when), the seats booked against the session's capacity, and how many are Attended, Not attended and Not marked. canMarkAttendance is true once the session has started, while it isn't cancelled, for a caller who may mark attendance. Authorised per session: admins with Courses.Read see every session's roster (marking needs Courses.Manage), and trainers with IltSessions.Deliver see and mark the roster of a session they are assigned to (LMS-203). Returns 403 for anyone else, including a trainer not assigned to the session, 404 for a session that doesn't exist, and 404 while the ilt feature flag is off
 * @summary Get a face-to-face training session's roster
 */
export const instructorLedGetSessionRoster = (
    sessionId: string,
 signal?: AbortSignal
) => {


      return apiClient<SessionRosterDto>(
      {url: `/api/instructor-led/sessions/${sessionId}/roster`, method: 'GET', signal
    },
      );
    }




export const getInstructorLedGetSessionRosterQueryKey = (sessionId: string,) => {
    return [
    `/api/instructor-led/sessions/${sessionId}/roster`
    ] as const;
    }


export const getInstructorLedGetSessionRosterQueryOptions = <TData = Awaited<ReturnType<typeof instructorLedGetSessionRoster>>, TError = void>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionRoster>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInstructorLedGetSessionRosterQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof instructorLedGetSessionRoster>>> = ({ signal }) => instructorLedGetSessionRoster(sessionId, signal);





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionRoster>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InstructorLedGetSessionRosterQueryResult = NonNullable<Awaited<ReturnType<typeof instructorLedGetSessionRoster>>>
export type InstructorLedGetSessionRosterQueryError = void


export function useInstructorLedGetSessionRoster<TData = Awaited<ReturnType<typeof instructorLedGetSessionRoster>>, TError = void>(
 sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionRoster>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof instructorLedGetSessionRoster>>,
          TError,
          Awaited<ReturnType<typeof instructorLedGetSessionRoster>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInstructorLedGetSessionRoster<TData = Awaited<ReturnType<typeof instructorLedGetSessionRoster>>, TError = void>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionRoster>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof instructorLedGetSessionRoster>>,
          TError,
          Awaited<ReturnType<typeof instructorLedGetSessionRoster>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInstructorLedGetSessionRoster<TData = Awaited<ReturnType<typeof instructorLedGetSessionRoster>>, TError = void>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionRoster>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a face-to-face training session's roster
 */

export function useInstructorLedGetSessionRoster<TData = Awaited<ReturnType<typeof instructorLedGetSessionRoster>>, TError = void>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionRoster>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInstructorLedGetSessionRosterQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Records the attendance of the learner holding the booking on the session (Attended or NotAttended), with who marked it (the caller) and when, and returns the roster. A mark can be changed later; marking the same again changes nothing. Moving into or out of Attended raises a signal that completion and the feedback request react to. Authorised per session: admins with Courses.Manage can mark every session, and trainers with IltSessions.Deliver the sessions they are assigned to (LMS-203). Returns 409 with a message before the session starts, for a cancelled session or booking, and when someone else changed the mark at the same moment; 400 for NotMarked; 403 for anyone else, including a trainer not assigned to the session; 404 for a session or booking that doesn't exist, and while the ilt feature flag is off
 * @summary Mark a booked learner Attended or Not attended
 */
export const instructorLedMarkSessionAttendance = (
    sessionId: string,
    bookingId: string,
    markAttendanceRequest: MarkAttendanceRequest,
 signal?: AbortSignal
) => {


      return apiClient<SessionRosterDto>(
      {url: `/api/instructor-led/sessions/${sessionId}/roster/${bookingId}/attendance`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: markAttendanceRequest, signal
    },
      );
    }




export const getInstructorLedMarkSessionAttendanceMutationKey = () => ['instructorLedMarkSessionAttendance'] as const;

export const getInstructorLedMarkSessionAttendanceMutationOptions = <TError = ProblemDetails | void | AttendanceRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedMarkSessionAttendance>>, TError,InstructorLedMarkSessionAttendanceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof instructorLedMarkSessionAttendance>>, TError,InstructorLedMarkSessionAttendanceMutationVariables, TContext> => {

const mutationKey = getInstructorLedMarkSessionAttendanceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof instructorLedMarkSessionAttendance>>, InstructorLedMarkSessionAttendanceMutationVariables> = (props) => {
          const {sessionId,bookingId,data} = props ?? {};

          return  instructorLedMarkSessionAttendance(sessionId,bookingId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstructorLedMarkSessionAttendanceMutationResult = NonNullable<Awaited<ReturnType<typeof instructorLedMarkSessionAttendance>>>
    export type InstructorLedMarkSessionAttendanceMutationBody = MarkAttendanceRequest
    export type InstructorLedMarkSessionAttendanceMutationError = ProblemDetails | void | AttendanceRefusalDto
    export type InstructorLedMarkSessionAttendanceMutationVariables = {sessionId: string;bookingId: string;data: MarkAttendanceRequest}

    /**
 * @summary Mark a booked learner Attended or Not attended
 */
export const useInstructorLedMarkSessionAttendance = <TError = ProblemDetails | void | AttendanceRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedMarkSessionAttendance>>, TError,InstructorLedMarkSessionAttendanceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof instructorLedMarkSessionAttendance>>,
        TError,
        InstructorLedMarkSessionAttendanceMutationVariables,
        TContext
      > => {
      return useMutation(getInstructorLedMarkSessionAttendanceMutationOptions(options), queryClient);
    }
    /**
 * Returns the resources shared with the session's learners (LMS-143): the course's (shared with every session; added by admins on the course's admin page) and the session's own, each oldest first, with its title and, for a link, its http or https address or, for a file, its name, size and download address (downloadUrl, relative to the API; the file is only served to those allowed to see it). canManage says whether the caller may add resources to the session and remove its own (canRemove on each), and limits gives the largest file and the file types that can be uploaded. Open to a learner holding a booking (not cancelled) on the session, before and after it, the session's trainers (IltSessions.Deliver) and admins with Courses.Read; 403 for anyone else, including a learner whose booking is cancelled or who is booked on another session. Returns 404 for a session that doesn't exist, and while the ilt feature flag is off
 * @summary List the files and links shared with a face-to-face training session's learners
 */
export const instructorLedGetSessionResources = (
    sessionId: string,
 signal?: AbortSignal
) => {


      return apiClient<SessionResourcesDto>(
      {url: `/api/instructor-led/sessions/${sessionId}/resources`, method: 'GET', signal
    },
      );
    }




export const getInstructorLedGetSessionResourcesQueryKey = (sessionId: string,) => {
    return [
    `/api/instructor-led/sessions/${sessionId}/resources`
    ] as const;
    }


export const getInstructorLedGetSessionResourcesQueryOptions = <TData = Awaited<ReturnType<typeof instructorLedGetSessionResources>>, TError = void>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionResources>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInstructorLedGetSessionResourcesQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof instructorLedGetSessionResources>>> = ({ signal }) => instructorLedGetSessionResources(sessionId, signal);





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionResources>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InstructorLedGetSessionResourcesQueryResult = NonNullable<Awaited<ReturnType<typeof instructorLedGetSessionResources>>>
export type InstructorLedGetSessionResourcesQueryError = void


export function useInstructorLedGetSessionResources<TData = Awaited<ReturnType<typeof instructorLedGetSessionResources>>, TError = void>(
 sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionResources>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof instructorLedGetSessionResources>>,
          TError,
          Awaited<ReturnType<typeof instructorLedGetSessionResources>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInstructorLedGetSessionResources<TData = Awaited<ReturnType<typeof instructorLedGetSessionResources>>, TError = void>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionResources>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof instructorLedGetSessionResources>>,
          TError,
          Awaited<ReturnType<typeof instructorLedGetSessionResources>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInstructorLedGetSessionResources<TData = Awaited<ReturnType<typeof instructorLedGetSessionResources>>, TError = void>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionResources>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the files and links shared with a face-to-face training session's learners
 */

export function useInstructorLedGetSessionResources<TData = Awaited<ReturnType<typeof instructorLedGetSessionResources>>, TError = void>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionResources>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInstructorLedGetSessionResourcesQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Uploads a file with a title (multipart/form-data: title, file) and shares it with the learners booked on the session (LMS-143). The file must be no larger than the limit (25 MB unless configured otherwise) and one of the allowed types: PDF, Word, Excel, PowerPoint or an image (PNG, JPG, GIF or WebP); its extension, content type and first bytes must all match. It is kept in a private container and served only through the download address. Returns the resource. Returns 400 with a message for a missing or overlong title, a missing or empty file, one over the size limit, or one of another type. Allowed for the session's trainers (IltSessions.Deliver) and admins with Courses.Manage; 403 for anyone else, including a trainer not assigned to the session. Returns 404 for a session that doesn't exist, and while the ilt feature flag is off
 * @summary Share a file with a face-to-face training session's learners
 */
export const instructorLedAddSessionResourceFile = (
    sessionId: string,
    addIltResourceFileRequest: AddIltResourceFileRequest,
 signal?: AbortSignal
) => {

      const formData = new FormData();
if(addIltResourceFileRequest.title !== undefined && addIltResourceFileRequest.title !== null) {
 formData.append(`title`, addIltResourceFileRequest.title);
 }
if(addIltResourceFileRequest.file !== undefined && addIltResourceFileRequest.file !== null) {
 formData.append(`file`, addIltResourceFileRequest.file);
 }

      return apiClient<IltResourceDto>(
      {url: `/api/instructor-led/sessions/${sessionId}/resources/files`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }




export const getInstructorLedAddSessionResourceFileMutationKey = () => ['instructorLedAddSessionResourceFile'] as const;

export const getInstructorLedAddSessionResourceFileMutationOptions = <TError = HttpValidationProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedAddSessionResourceFile>>, TError,InstructorLedAddSessionResourceFileMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof instructorLedAddSessionResourceFile>>, TError,InstructorLedAddSessionResourceFileMutationVariables, TContext> => {

const mutationKey = getInstructorLedAddSessionResourceFileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof instructorLedAddSessionResourceFile>>, InstructorLedAddSessionResourceFileMutationVariables> = (props) => {
          const {sessionId,data} = props ?? {};

          return  instructorLedAddSessionResourceFile(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstructorLedAddSessionResourceFileMutationResult = NonNullable<Awaited<ReturnType<typeof instructorLedAddSessionResourceFile>>>
    export type InstructorLedAddSessionResourceFileMutationBody = AddIltResourceFileRequest
    export type InstructorLedAddSessionResourceFileMutationError = HttpValidationProblemDetails | void
    export type InstructorLedAddSessionResourceFileMutationVariables = {sessionId: string;data: AddIltResourceFileRequest}

    /**
 * @summary Share a file with a face-to-face training session's learners
 */
export const useInstructorLedAddSessionResourceFile = <TError = HttpValidationProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedAddSessionResourceFile>>, TError,InstructorLedAddSessionResourceFileMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof instructorLedAddSessionResourceFile>>,
        TError,
        InstructorLedAddSessionResourceFileMutationVariables,
        TContext
      > => {
      return useMutation(getInstructorLedAddSessionResourceFileMutationOptions(options), queryClient);
    }
    /**
 * Shares a link with a title with the learners booked on the session (LMS-143). Only absolute http and https addresses are accepted. Returns the resource. Returns 400 with a message for a missing or overlong title or an address that is missing or isn't http or https. Allowed for the session's trainers (IltSessions.Deliver) and admins with Courses.Manage; 403 for anyone else, including a trainer not assigned to the session. Returns 404 for a session that doesn't exist, and while the ilt feature flag is off
 * @summary Share a link with a face-to-face training session's learners
 */
export const instructorLedAddSessionResourceLink = (
    sessionId: string,
    addIltResourceLinkRequest: AddIltResourceLinkRequest,
 signal?: AbortSignal
) => {


      return apiClient<IltResourceDto>(
      {url: `/api/instructor-led/sessions/${sessionId}/resources/links`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addIltResourceLinkRequest, signal
    },
      );
    }




export const getInstructorLedAddSessionResourceLinkMutationKey = () => ['instructorLedAddSessionResourceLink'] as const;

export const getInstructorLedAddSessionResourceLinkMutationOptions = <TError = HttpValidationProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedAddSessionResourceLink>>, TError,InstructorLedAddSessionResourceLinkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof instructorLedAddSessionResourceLink>>, TError,InstructorLedAddSessionResourceLinkMutationVariables, TContext> => {

const mutationKey = getInstructorLedAddSessionResourceLinkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof instructorLedAddSessionResourceLink>>, InstructorLedAddSessionResourceLinkMutationVariables> = (props) => {
          const {sessionId,data} = props ?? {};

          return  instructorLedAddSessionResourceLink(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstructorLedAddSessionResourceLinkMutationResult = NonNullable<Awaited<ReturnType<typeof instructorLedAddSessionResourceLink>>>
    export type InstructorLedAddSessionResourceLinkMutationBody = AddIltResourceLinkRequest
    export type InstructorLedAddSessionResourceLinkMutationError = HttpValidationProblemDetails | void
    export type InstructorLedAddSessionResourceLinkMutationVariables = {sessionId: string;data: AddIltResourceLinkRequest}

    /**
 * @summary Share a link with a face-to-face training session's learners
 */
export const useInstructorLedAddSessionResourceLink = <TError = HttpValidationProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedAddSessionResourceLink>>, TError,InstructorLedAddSessionResourceLinkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof instructorLedAddSessionResourceLink>>,
        TError,
        InstructorLedAddSessionResourceLinkMutationVariables,
        TContext
      > => {
      return useMutation(getInstructorLedAddSessionResourceLinkMutationOptions(options), queryClient);
    }
    /**
 * Removes one of the session's own resources (LMS-143), so its learners no longer see it, and deletes its file. The course's resources are removed on the course's admin page instead. Allowed for the session's trainers (IltSessions.Deliver) and admins with Courses.Manage; 403 for anyone else, including a trainer not assigned to the session. Returns 404 for a session or resource that doesn't exist, a resource of another session or of the course, and while the ilt feature flag is off
 * @summary Remove a file or link from a face-to-face training session
 */
export const instructorLedRemoveSessionResource = (
    sessionId: string,
    resourceId: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/instructor-led/sessions/${sessionId}/resources/${resourceId}`, method: 'DELETE', signal
    },
      );
    }




export const getInstructorLedRemoveSessionResourceMutationKey = () => ['instructorLedRemoveSessionResource'] as const;

export const getInstructorLedRemoveSessionResourceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedRemoveSessionResource>>, TError,InstructorLedRemoveSessionResourceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof instructorLedRemoveSessionResource>>, TError,InstructorLedRemoveSessionResourceMutationVariables, TContext> => {

const mutationKey = getInstructorLedRemoveSessionResourceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof instructorLedRemoveSessionResource>>, InstructorLedRemoveSessionResourceMutationVariables> = (props) => {
          const {sessionId,resourceId} = props ?? {};

          return  instructorLedRemoveSessionResource(sessionId,resourceId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstructorLedRemoveSessionResourceMutationResult = NonNullable<Awaited<ReturnType<typeof instructorLedRemoveSessionResource>>>

    export type InstructorLedRemoveSessionResourceMutationError = void
    export type InstructorLedRemoveSessionResourceMutationVariables = {sessionId: string;resourceId: string}

    /**
 * @summary Remove a file or link from a face-to-face training session
 */
export const useInstructorLedRemoveSessionResource = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedRemoveSessionResource>>, TError,InstructorLedRemoveSessionResourceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof instructorLedRemoveSessionResource>>,
        TError,
        InstructorLedRemoveSessionResourceMutationVariables,
        TContext
      > => {
      return useMutation(getInstructorLedRemoveSessionResourceMutationOptions(options), queryClient);
    }
    /**
 * Streams a shared file (LMS-143) as an attachment (Content-Disposition: attachment, with its file name) with X-Content-Type-Options: nosniff, never from an anonymous blob address. Checked on every download: a session's file is served to learners holding a booking (not cancelled) on that session and a course's file to learners holding one on any of the course's sessions, to the trainers assigned to that session (or, for a course's file, to any of its sessions), and to admins with Courses.Read. Returns 401 when signed out, 403 for anyone else (including a learner whose booking has been cancelled), and 404 for a resource that doesn't exist or is a link, and while the ilt feature flag is off
 * @summary Download a file shared with a face-to-face training session's learners
 */
export const instructorLedDownloadResourceFile = (
    resourceId: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/instructor-led/resources/${resourceId}/file`, method: 'GET', signal
    },
      );
    }




export const getInstructorLedDownloadResourceFileQueryKey = (resourceId: string,) => {
    return [
    `/api/instructor-led/resources/${resourceId}/file`
    ] as const;
    }


export const getInstructorLedDownloadResourceFileQueryOptions = <TData = Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>, TError = void>(resourceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInstructorLedDownloadResourceFileQueryKey(resourceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>> = ({ signal }) => instructorLedDownloadResourceFile(resourceId, signal);





   return  { queryKey, queryFn, enabled: resourceId !== null && resourceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InstructorLedDownloadResourceFileQueryResult = NonNullable<Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>>
export type InstructorLedDownloadResourceFileQueryError = void


export function useInstructorLedDownloadResourceFile<TData = Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>, TError = void>(
 resourceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>,
          TError,
          Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInstructorLedDownloadResourceFile<TData = Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>, TError = void>(
 resourceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>,
          TError,
          Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInstructorLedDownloadResourceFile<TData = Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>, TError = void>(
 resourceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download a file shared with a face-to-face training session's learners
 */

export function useInstructorLedDownloadResourceFile<TData = Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>, TError = void>(
 resourceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedDownloadResourceFile>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInstructorLedDownloadResourceFileQueryOptions(resourceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns the signed-in learner's bookings, upcoming and past, soonest session first, each with its course's title and picture and the session's date, time and venue. A booking on a session that has ended has isPast set (My Learning lists it under Past). A booking the learner has cancelled stays listed with isCancelled and cancelledAt set; when they have booked the session again, only that booking is listed, so each session appears once. A session an admin has cancelled stays listed with isSessionCancelled set. Each active booking's session says whether the learner can cancel it online (canCancel, until cancellableUntil) or the cancellation cut-off has passed (isTooLateToCancel). Each booking says whether the learner attended (attendance: NotMarked until it is marked on the session's roster, then Attended or NotAttended). canGiveFeedback is true while an active booking is marked Attended and the learner hasn't given feedback on its session (LMS-138), whose form opens at /api/instructor-led/bookings/{bookingId}/feedback. Returns 404 while the ilt feature flag is off
 * @summary List the learner's face-to-face training bookings, upcoming and past
 */
export const instructorLedListMyBookings = (

 signal?: AbortSignal
) => {


      return apiClient<IltBookingDto[]>(
      {url: `/api/instructor-led/bookings/mine`, method: 'GET', signal
    },
      );
    }




export const getInstructorLedListMyBookingsQueryKey = () => {
    return [
    `/api/instructor-led/bookings/mine`
    ] as const;
    }


export const getInstructorLedListMyBookingsQueryOptions = <TData = Awaited<ReturnType<typeof instructorLedListMyBookings>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedListMyBookings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInstructorLedListMyBookingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof instructorLedListMyBookings>>> = ({ signal }) => instructorLedListMyBookings(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof instructorLedListMyBookings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InstructorLedListMyBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof instructorLedListMyBookings>>>
export type InstructorLedListMyBookingsQueryError = void


export function useInstructorLedListMyBookings<TData = Awaited<ReturnType<typeof instructorLedListMyBookings>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedListMyBookings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof instructorLedListMyBookings>>,
          TError,
          Awaited<ReturnType<typeof instructorLedListMyBookings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInstructorLedListMyBookings<TData = Awaited<ReturnType<typeof instructorLedListMyBookings>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedListMyBookings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof instructorLedListMyBookings>>,
          TError,
          Awaited<ReturnType<typeof instructorLedListMyBookings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInstructorLedListMyBookings<TData = Awaited<ReturnType<typeof instructorLedListMyBookings>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedListMyBookings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the learner's face-to-face training bookings, upcoming and past
 */

export function useInstructorLedListMyBookings<TData = Awaited<ReturnType<typeof instructorLedListMyBookings>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedListMyBookings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInstructorLedListMyBookingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns the feedback form for the session of the signed-in learner's booking, once they were marked Attended on it (LMS-138), with what the LMS already knows filled in: their name and email (from their account), the course, the session's date and its trainers (from the booking; "The trainer was knowledgeable" is asked once for each), and their employer and Newsletter setting (from their profile; employer null when the profile has none). feedbackGiven is true, with feedbackGivenAt, once they have given feedback on the session, which is given once. Returns 404 for a booking that doesn't exist or isn't the learner's (so someone else's email link is refused), 409 with reason not-attended when the booking isn't marked Attended or is cancelled, and 404 while the ilt feature flag is off
 * @summary Get the feedback form of a face-to-face session the learner attended
 */
export const instructorLedGetSessionFeedbackForm = (
    bookingId: string,
 signal?: AbortSignal
) => {


      return apiClient<IltFeedbackFormDto>(
      {url: `/api/instructor-led/bookings/${bookingId}/feedback`, method: 'GET', signal
    },
      );
    }




export const getInstructorLedGetSessionFeedbackFormQueryKey = (bookingId: string,) => {
    return [
    `/api/instructor-led/bookings/${bookingId}/feedback`
    ] as const;
    }


export const getInstructorLedGetSessionFeedbackFormQueryOptions = <TData = Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>, TError = void | IltFeedbackRefusalDto>(bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInstructorLedGetSessionFeedbackFormQueryKey(bookingId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>> = ({ signal }) => instructorLedGetSessionFeedbackForm(bookingId, signal);





   return  { queryKey, queryFn, enabled: bookingId !== null && bookingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InstructorLedGetSessionFeedbackFormQueryResult = NonNullable<Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>>
export type InstructorLedGetSessionFeedbackFormQueryError = void | IltFeedbackRefusalDto


export function useInstructorLedGetSessionFeedbackForm<TData = Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>, TError = void | IltFeedbackRefusalDto>(
 bookingId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>,
          TError,
          Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInstructorLedGetSessionFeedbackForm<TData = Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>, TError = void | IltFeedbackRefusalDto>(
 bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>,
          TError,
          Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInstructorLedGetSessionFeedbackForm<TData = Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>, TError = void | IltFeedbackRefusalDto>(
 bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the feedback form of a face-to-face session the learner attended
 */

export function useInstructorLedGetSessionFeedbackForm<TData = Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>, TError = void | IltFeedbackRefusalDto>(
 bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof instructorLedGetSessionFeedbackForm>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInstructorLedGetSessionFeedbackFormQueryOptions(bookingId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Saves the signed-in learner's feedback on the session of their booking (LMS-138): ARC's PDA evaluation. Ratings run from 1 (low) to 6 (high). learningOutcomesExplained, materialsHelpful, knowledgeIncreased, confidenceIncreased, likelyToChangePractice and workPracticeImproved are required, and trainerRatings rates each trainer on the session now, once (none when it has no trainers). heardAbout, wouldRecommend and wantsContact are required, and heardAboutOther when heardAbout is Other; comments are optional and kept as written. employer is saved to the learner's profile, and recorded on the feedback, when the profile has none; the profile's employer is kept otherwise. receiveNewsletter turns the profile's Newsletter setting on; it never turns it off. Feedback is given once per session. Returns 204 when saved; 400 for a missing or out-of-range answer; 404 for a booking that doesn't exist or isn't the learner's; 409 with a reason when the booking isn't marked Attended or is cancelled (not-attended), feedback has already been given on the session (already-given), or the session's trainers changed since the form was read (trainers-changed). An attendance change made at the same moment either comes first (and the feedback is refused) or waits for it; and 404 while the ilt feature flag is off
 * @summary Give feedback on a face-to-face session the learner attended
 */
export const instructorLedSubmitSessionFeedback = (
    bookingId: string,
    submitIltFeedbackRequest: SubmitIltFeedbackRequest,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/instructor-led/bookings/${bookingId}/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitIltFeedbackRequest, signal
    },
      );
    }




export const getInstructorLedSubmitSessionFeedbackMutationKey = () => ['instructorLedSubmitSessionFeedback'] as const;

export const getInstructorLedSubmitSessionFeedbackMutationOptions = <TError = ProblemDetails | void | IltFeedbackRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedSubmitSessionFeedback>>, TError,InstructorLedSubmitSessionFeedbackMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof instructorLedSubmitSessionFeedback>>, TError,InstructorLedSubmitSessionFeedbackMutationVariables, TContext> => {

const mutationKey = getInstructorLedSubmitSessionFeedbackMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof instructorLedSubmitSessionFeedback>>, InstructorLedSubmitSessionFeedbackMutationVariables> = (props) => {
          const {bookingId,data} = props ?? {};

          return  instructorLedSubmitSessionFeedback(bookingId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstructorLedSubmitSessionFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof instructorLedSubmitSessionFeedback>>>
    export type InstructorLedSubmitSessionFeedbackMutationBody = SubmitIltFeedbackRequest
    export type InstructorLedSubmitSessionFeedbackMutationError = ProblemDetails | void | IltFeedbackRefusalDto
    export type InstructorLedSubmitSessionFeedbackMutationVariables = {bookingId: string;data: SubmitIltFeedbackRequest}

    /**
 * @summary Give feedback on a face-to-face session the learner attended
 */
export const useInstructorLedSubmitSessionFeedback = <TError = ProblemDetails | void | IltFeedbackRefusalDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof instructorLedSubmitSessionFeedback>>, TError,InstructorLedSubmitSessionFeedbackMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof instructorLedSubmitSessionFeedback>>,
        TError,
        InstructorLedSubmitSessionFeedbackMutationVariables,
        TContext
      > => {
      return useMutation(getInstructorLedSubmitSessionFeedbackMutationOptions(options), queryClient);
    }
